import Acessos from '@/views/pages/acessos/Acessos.vue'


export default [
    {
        path: '/acessos',
        name: 'Acessos',
        component: Acessos,
        meta: {
            page: {
                title: 'Acessos'
            },
            menu: {
                title: 'Acessos',
                icon: 'dashboard'
            },
        }
    }
]
